import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { alertColors } from '../../styles/colors/colors.js';
import { spacing1x, spacing2x } from '../../styles/spacing.js';
import { Box } from '../Box/Box.js';
import { IconStatusCheck } from '../Icons/IconStatusCheck.js';
import { IconStatusError } from '../Icons/IconStatusError.js';
import { IconStatusInformation } from '../Icons/IconStatusInformation.js';
import { IconStatusWarning } from '../Icons/IconStatusWarning.js';
import { IconSync } from '../Icons/IconSync.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["borderWidth", "children", "hideStrip", "style", "type", "variant"];
var alertColorMap = {
  error: alertColors.error,
  info: alertColors.information,
  success: alertColors.success,
  warning: alertColors.warning,
  progress: alertColors.warning
};
var iconMap = {
  error: IconStatusError,
  info: IconStatusInformation,
  success: IconStatusCheck,
  warning: IconStatusWarning,
  progress: IconSync
};
var roleMap = {
  error: "alert",
  info: "status",
  success: "status",
  warning: "alert",
  progress: "status"
};
var alertBorderWidth = spacing2x;
var Border = styled.div.withConfig({
  displayName: "Alert__Border",
  componentId: "sc-igw24h-0"
})(["&&{border-start-start-radius:", ";border-end-start-radius:", ";", ";}"], spacing1x, spacing1x, function (props) {
  if (!props.hideStrip) {
    return "border-inline-start: ".concat(alertBorderWidth, " solid ").concat(alertColorMap[props.variant], ";");
  }
});
var IconWrapper = styled.span.withConfig({
  displayName: "Alert__IconWrapper",
  componentId: "sc-igw24h-1"
})(["&&{color:", ";padding-inline-end:", ";vertical-align:bottom;}"], function (_ref) {
  var variant = _ref.variant;
  return alertColorMap[variant];
}, spacing2x);
var StyledAlert = styled(Box).withConfig({
  displayName: "Alert__StyledAlert",
  componentId: "sc-igw24h-2"
})(["&&{border-inline-start:0;border-radius:", ";", ";}"], spacing1x, function (props) {
  if (!props.hideStrip) {
    return "\n                border-start-start-radius: 0;\n                border-end-start-radius: 0;\n            ";
  }
});
var Alert = /*#__PURE__*/React.forwardRef(function Alert2(props, ref) {
  var _props$borderWidth = props.borderWidth,
    borderWidth = _props$borderWidth === void 0 ? 1 : _props$borderWidth,
    children = props.children,
    _props$hideStrip = props.hideStrip,
    hideStrip = _props$hideStrip === void 0 ? false : _props$hideStrip,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    type = props.type,
    variant = props.variant,
    rest = _objectWithoutProperties(props, _excluded);
  var Icon = iconMap[variant];
  return /*#__PURE__*/jsx(Border, {
    variant: variant,
    style: style,
    hideStrip: hideStrip,
    children: /*#__PURE__*/jsxs(StyledAlert, _objectSpread(_objectSpread({}, rest), {}, {
      borderWidth: borderWidth,
      elevation: type === "toast" ? 4 : void 0,
      hideStrip: hideStrip,
      padding: type === "toast" ? 4 : void 0,
      ref: ref,
      children: [/*#__PURE__*/jsx(IconWrapper, {
        variant: variant,
        children: /*#__PURE__*/jsx(Icon, {})
      }), children]
    }))
  });
});
Alert.displayName = "Alert";

export { Alert, roleMap };
